import { Icon } from "../ui/Icon.jsx";
import { Button } from "../ui/Button.jsx";

export function Effects() {
  return (
    <section className="section effects" id="effects">
      <div className="container">
        <div className="effectsGlass effectsGlass--author">
          <div className="sectionHead" data-reveal>
            <h2 className="h2">Личный кабинет автора</h2>
            <p className="muted">
              Позволит вам получать уведомления о новых нарушениях,
              следить за статусом работы с нарушениями и получать отчеты о поступающих компенсациях.
            </p>
          </div>

          <div className="grid2">
          <article className="card demo" data-reveal>
            <div className="demoTop">
              <h3 className="h3">Контроль за статусом проработки нарушения</h3>
              {/* <span className="muted">IntersectionObserver</span> */}
            </div>
            <div className="processStages" aria-hidden="true">
              {[
                { label: "Выявление", key: "1" },
                { label: "Фиксация", key: "2" },
                { label: "Проработка", key: "3" },
                { label: "Компенсация", key: "4" }
              ].map((stage, i) => (
                <div key={stage.key} className="processStage">
                  <div className="processStageBlock">
                    <div className="processStageDot" />
                    <span className="processStageLabel">{stage.label}</span>
                  </div>
                  {i < 3 ? <div className="processStageConnector" /> : null}
                </div>
              ))}
            </div>
            <p className="muted">
              Вы можете следить за всеми стадиями процесса от выявления нарушения до получения компенсации.
            </p>
          </article>

          <article className="card demo" data-reveal>
            <div className="demoTop">
              <h3 className="h3">Компенсации</h3>
              <span className="muted">Заработок без лишних усилий</span>
            </div>
            <div className="moneyFly" aria-hidden="true">
              <div className="moneyFlySource" title="Источник выплат">
                <span className="moneyFlyStack">₽</span>
              </div>
              <div className="moneyFlyTrack">
                {[0, 1, 2].map((i) => (
                  <div
                    key={i}
                    className="moneyFlyCoin"
                    style={{ animationDelay: `${i * 0.4}s` }}
                  />
                ))}
              </div>
              <div className="moneyFlyTarget" title="Ваш кошелёк">
                <span className="moneyFlyWallet" aria-hidden="true">👛</span>
              </div>
            </div>
            <p className="muted">
              Вам доступна статистика по всем полученным компенсациям.
            </p>
          </article>

          <article className="card demo" data-reveal>
            <div className="demoTop">
              <h3 className="h3">Рейтинги</h3>
              <span className="muted">Узнайте насколько вы знамениты у нарушителей</span>
            </div>
            <ul className="ratingList" aria-label="Рейтинги по критериям">
              {[
                { place: 1, label: "У кого больше украли" },
                { place: 2, label: "Что больше воровалось" },
                // { place: 3, label: "и др" }
              ].map((item) => (
                <li key={item.place} className="ratingRow">
                  <span className="ratingPlace">{item.place}</span>
                  <span className="ratingLabel">{item.label}</span>
                </li>
              ))}
            </ul>
            <p className="muted">Игровая статистика. Подсчет индекса воруемости и топ-5 по по различным критериям</p>
          </article>

          <article className="card demo" data-reveal>
            <div className="demoTop">
              <h3 className="h3">Контроль</h3>
              <span className="muted">Возможность выбора</span>
            </div>
            <div className="controlChoice" aria-hidden="true">
              <span className="controlOption">Наказать</span>
              <div className="controlToggle">
                <div className="controlTrack">
                  <div className="controlThumb" title="Вы выбираете" />
                </div>
              </div>
              <span className="controlOption">Не наказывать</span>
            </div>
            <p className="muted">
              Решайте сами запускать ход делу о нарушении или нет. Или доверьте всё нашим экспертам.
            </p>
          </article>
          </div>

          <div className="effectsGlassCta" data-reveal>
            <Button as="a" href="/author" variant="primary">
              Перейти в личный кабинет
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

